import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../auth/RutaAutenticada';

import VerCertificaciones from './certificaciones/VerCertificaciones';
import EditarCertificaciones from './certificaciones/EditarCertificacion';

import VerDeclaracionesJuradas from './declaracionJurada/verDeclaracionesJuradas';
import EditarDeclaracionJurada from './declaracionJurada/EditarDeclaracionJurada';

import VerAcreditaciones from './acreditaciones/VerAcreditaciones';

import VerAutorizacionesMenores from './autorizaciones/VerAutorizacionesMenores';
import EditarAutorizacionMenor from './autorizaciones/EditarAutorizacionMenor';

import VerAutorizacionesTrabajoMenor from './autorizaciones/VerAutorizacionesTrabajoMenor'
import EditarAutorizacionesTrabajoMenor from './autorizaciones/EditarAutorizacionesTrabajoMenor'

import VerAutorizacionesOtras from './autorizaciones/VerAutorizacionesOtras';
import EditarAutorizacionOtra from './autorizaciones/EditarAutorizacionOtra';

import VerPersonas from './personas/VerPersonas';
import EditarPersona from './personas/EditarPersona';

import VerUsuarios from './usuarios/VerUsuarios';
import EditarUsuario from './usuarios/EditarUsuario';
import CrearUsuario from './usuarios/CrearUsuario';

import CrearCategoria from './otros/categorias/CrearCategoria';
import VerCategorias from './otros/categorias/VerCategorias';
import EditarCategoria from './otros/categorias/EditarCategoria';

import CrearMedida from './otros/medidas/CrearMedida';
import VerMedidas from './otros/medidas/VerMedidas';
import EditarMedida from './otros/medidas/EditarMedida';

import CrearClasificadorEstadistico from './otros/clasificadores/CrearClasificadorEstadistico';
import VerClasificadorEstadistico from './otros/clasificadores/VerClasificadoresEstadisticos';

import CrearTalonario from './otros/talonarios/CrearTalonario';
import VerTalonarios from './otros/talonarios/VerTalonarios';
import EditarTalonario from './otros/talonarios/EditarTalonario';

import CrearTipoSello from './otros/tipo_sellos/CrearTipoSello';
import VerTiposSellos from './otros/tipo_sellos/VerTiposSellos';
import EditarTipoSello from './otros/tipo_sellos/EditarTipoSello';

import CrearTipoCertificacion from './otros/tipo_certificaciones/CrearTipoCertificacion';
import EditarTipoCertificacion from './otros/tipo_certificaciones/EditarTipoCertificacion';
import VerTipoCertificacion from './otros/tipo_certificaciones/VerTipoCertificaciones';

import CrearTipoAtencion from './otros/tipo_atenciones/CrearTipoAtencion';
import VerTipoAtencion from './otros/tipo_atenciones/VerTipoAtenciones';

import VerAtenciones from './atenciones/VerAtenciones';

import CrearNota from '../editor/CrearContainer';
import EditarNota from '../editor/EditarContainer';
import ListarNotas from '../editor/ListarModelosNotas';

import VerOrganismos from './organismos/VerOrganismos';
import EditarOrganismo from './organismos/EditarOrganismo';
import CrearOrganismo from './organismos/CrearOrganismo';

import VerDepositos from './depositos/VerDepositos';
import EditarDeposito from './depositos/EditarDeposito';

import VerInformacionSumaria from './informacionSumaria/VerInformacionSumaria';
import EditarInformacionSumaria from './informacionSumaria/EditarInformacionSumaria';

import SumarPersona from '../tramites/Autorizaciones/SumarPersona';

import CrearArticulo from './otros/articulos/CrearArticulo';
import VerArticulos from './otros/articulos/VerArticulos';
import EditarArticulo from './otros/articulos/EditarArticulo';

import ListarOficios from './oficios/ListarOficios';
import EditarOficio from './oficios/EditarOficio';

import ListarRegistrosEntradaSalida from './registroEntradaSalida/ListarRegistroEntradaSalida';
import EditarRegistroEntradaSalida from './registroEntradaSalida/EditarRegistroEntradaSalida';

import * as Roles from '../common/DeclaracionRoles';

import ReImprimirNota from './ReImprimirNota';
import EditarClasificadorEstadistico from './otros/clasificadores/EditarClasificadorEstadistico';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
      // style={{
      //   padding: "0 24px 24px"
      // }}
      >
        <Content
        // style={{
        //   padding: "0 24px 24px 24px",
        //   margin: 0
        // }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path="/admin/editor/nueva"
              component={CrearNota}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />
            <RutaAutenticada
              exact
              path="/admin/editor/listar"
              component={ListarNotas}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.FUNCIONARIO,
              ]}
            />
            <RutaAutenticada
              exact
              path="/admin/editor/:id"
              component={EditarNota}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/certificaciones`}
              component={VerCertificaciones}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/atenciones`}
              component={VerAtenciones}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/certificaciones/:id`}
              component={EditarCertificaciones}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/declaraciones`}
              component={VerDeclaracionesJuradas}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/acreditaciones`}
              component={VerAcreditaciones}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/declaraciones/:id`}
              component={EditarDeclaracionJurada}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_viajes`}
              component={VerAutorizacionesMenores}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_viajes/agregarPersona`}
              component={SumarPersona}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_viajes/:id`}
              component={EditarAutorizacionMenor}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_trabajo_menor`}
              component={VerAutorizacionesTrabajoMenor}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_trabajo_menor/:id`}
              component={EditarAutorizacionesTrabajoMenor}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_otras`}
              component={VerAutorizacionesOtras}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/autorizaciones_otras/:id`}
              component={EditarAutorizacionOtra}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/personas`}
              component={VerPersonas}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/personas/:id`}
              component={EditarPersona}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/usuarios/crear`}
              component={CrearUsuario}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.DGJP_DIRECTOR,
                Roles.SUPERVISOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/usuarios/:id`}
              component={EditarUsuario}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/usuarios`}
              component={VerUsuarios}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/organismos`}
              component={VerOrganismos}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/organismos/crear`}
              component={CrearOrganismo}
              rolesAutorizados={[Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/organismos/:id`}
              component={EditarOrganismo}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/categorias`}
              component={VerCategorias}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/categorias/crear`}
              component={CrearCategoria}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/categorias/:id`}
              component={EditarCategoria}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/medidas`}
              component={VerMedidas}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/medidas/crear`}
              component={CrearMedida}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/medidas/:id`}
              component={EditarMedida}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/clasificadoresEstadisticos`}
              component={VerClasificadorEstadistico}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/clasificadoresEstadisticos/crear`}
              component={CrearClasificadorEstadistico}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/clasificadoresEstadisticos/:id`}
              component={EditarClasificadorEstadistico}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/articulos`}
              component={VerArticulos}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/articulos/crear`}
              component={CrearArticulo}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/articulos/:id`}
              component={EditarArticulo}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/talonarios`}
              component={VerTalonarios}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/talonarios/crear`}
              component={CrearTalonario}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/talonarios/:id`}
              component={EditarTalonario}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_sello`}
              component={VerTiposSellos}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.ADMINISTRADOR,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_sello/crear`}
              component={CrearTipoSello}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.ADMINISTRADOR,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_sello/:id`}
              component={EditarTipoSello}
              rolesAutorizados={[Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_certificacion`}
              component={VerTipoCertificacion}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_certificacion/crear`}
              component={CrearTipoCertificacion}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_certificacion/:id`}
              component={EditarTipoCertificacion}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_atencion`}
              component={VerTipoAtencion}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otros/tipo_atencion/crear`}
              component={CrearTipoAtencion}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/depositos/:id`}
              component={EditarDeposito}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.ADMINISTRADOR,
                Roles.SUPERVISOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/depositos`}
              component={VerDepositos}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.ADMINISTRADOR,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/informacionesSumarias/:id`}
              component={EditarInformacionSumaria}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/informacionesSumarias`}
              component={VerInformacionSumaria}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/oficios/:id`}
              component={EditarOficio}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/oficios`}
              component={ListarOficios}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/registrosEntradasSalidas/:id`}
              component={EditarRegistroEntradaSalida}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/registrosEntradasSalidas`}
              component={ListarRegistrosEntradaSalida}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.CONFIGURACION,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/reImprimirNota`}
              component={ReImprimirNota}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Index.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Index;
